@if (showLoader | async) {
  <div [@scaleUpDown] class="loader-container">
    <!-- <div class="loader__wrapper">
      <span class="loader__dot"></span>
      <span class="loader__dot"></span>
      <span class="loader__dot"></span>
    </div> -->
    <div class="spinner"></div>
  </div>
}
